export default {
  General: 0,
  Science: 1,
  Statistic: 2,
  DangAudit: 3,
  StateAudit: 4,
  SGDHaiDuong : 5,
  STCLongAn : 6
};
  